import {BettingAdResponseApiModel} from "../models/betting-ad.response-api-model";
import {BettingAdDataSource} from "../models/betting-ad.data-source";
import {BaseFactory} from "../../../infrastructure/factories/base-factory";
import type {BaseApiRequestModel} from "../../../infrastructure/models/base-api-request-model";
import type {BettingAdPromotionApiModel} from "../models/promotion/betting-ad.promotion.api-model";
import {BettingAdPromotionDomainModel} from "../models/promotion/betting-ad.promotion.domain-model";
import {BettingAdBookmakerDomainModel} from "../models/bookmaker/betting-ad.bookmaker.domain-model";
import {BettingAdBoostDomainModel} from "../models/boost/betting-ad.boost.domain-model";
import {BettingAdBetBoostApiModel} from "../models/boost/betting-ad.bet-boost.api-model";

export class BettingAdFactory extends BaseFactory {
  static injectables = [...BaseFactory.injectables];

  createResponse(apiModel: BettingAdResponseApiModel, request: BaseApiRequestModel): BettingAdResponseApiModel {
    const responseApiModel: BettingAdResponseApiModel = new BettingAdResponseApiModel(apiModel, request);

    return responseApiModel;
  }

  createDomainModel(apiModel: BettingAdResponseApiModel): BettingAdDataSource {
    if (!apiModel) {
      return null;
    }

    const boosts: Array<BettingAdBoostDomainModel> = apiModel.betBoosts?.map((bet: BettingAdBetBoostApiModel): BettingAdBoostDomainModel => {
      return bet.boosts.map(boost =>  new BettingAdBoostDomainModel(boost, bet.game.ID))
    }).flat();

    const promotions: Array<BettingAdPromotionDomainModel> = apiModel.promotions?.map((promotion: BettingAdPromotionApiModel) => new BettingAdPromotionDomainModel(promotion));
    const bookmakersMap: Map<Number, BettingAdBookmakerDomainModel> = this.createDomainMap(apiModel.bookmakers, BettingAdBookmakerDomainModel, 'id');

    const model: BettingAdDataSource = new BettingAdDataSource(apiModel, promotions, boosts, bookmakersMap)

    return model;
  }
}


